import type { IConfigCatCache } from "configcat-js";

const DB_NAME = "configcat";
const STORE_NAME = "configcat-js-cache";
const DB_VERSION = 1;

export class ConfigCatCustomCache implements IConfigCatCache {
  private db: Promise<IDBDatabase> | IDBDatabase | null = null;

  constructor() {
    try {
      this.initDB();
    } catch (err: unknown) {
      console.error("Failed to init ConfigCatCustomCache", err);
    }
  }

  private initDB(): Promise<IDBDatabase> {
    this.db = new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);

      request.onerror = () => {
        reject(new Error("Failed to open configcat in IndexedDB"));
      };

      request.onsuccess = (event) => {
        resolve((event.target as IDBOpenDBRequest).result);
      };

      request.onupgradeneeded = (event) => {
        const db = (event.target as IDBOpenDBRequest).result;
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME);
        }
      };
    });
    return this.db;
  }

  async set(key: string, value: string): Promise<void> {
    const db = await this.db;
    return new Promise((resolve, reject) => {
      if (!db) {
        return reject(new Error("Database failed to initialise"));
      }
      const transaction = db.transaction(STORE_NAME, "readwrite");
      const store = transaction.objectStore(STORE_NAME);
      const request = store.put(value, key);

      request.onsuccess = () => {
        localStorage.removeItem(key);
        resolve();
      };
      request.onerror = () => {
        reject(new Error("Failed to store configcat-js-cache in IndexedDB"));
      };
    });
  }

  async get(key: string): Promise<string | null | undefined> {
    const db = await this.db;
    return new Promise((resolve, reject) => {
      if (!db) {
        return reject(new Error("Database failed to initialise"));
      }
      const transaction = db.transaction(STORE_NAME, "readonly");
      const store = transaction.objectStore(STORE_NAME);
      const request = store.get(key);

      request.onsuccess = () => {
        localStorage.removeItem(key);
        resolve(request.result);
      };
      request.onerror = () => {
        reject(
          new Error("Failed to retrieve configcat-js-cache from IndexedDB")
        );
      };
    });
  }
}
